var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('rect',{attrs:{"x":"2.5","y":"2.5","width":"19","height":"19","rx":"9.5","fill":"white","stroke":"currentColor"}})])}
var staticRenderFns = []

export { render, staticRenderFns }